import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftWheelProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearLeftWheel(props: RearLeftWheelProps) {
  return (
    <svg
      width="178"
      height="66"
      viewBox="0 0 178 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{right: 213, bottom: 10}}
      onClick={props.onClick}
    >
      <path
        d="M153 1H89H25C15 1 1 4 1 18V33V48C1 62 12 65 18 65H89H160C166 65 177 62 177 48L177 33L177 18C177 4 163 1 153 1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M153 1H89H25C15 1 1 4 1 18V33V48C1 62 12 65 18 65H89H160C166 65 177 62 177 48L177 33L177 18C177 4 163 1 153 1Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M170 5C170 5 135 7 89 7C43 7 8 5 8 5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 27C70 24.3333 109 24.3333 177 27"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 35H177"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 43C70 45.6667 109 45.6667 177 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M14 65C5.03705 61 6.03293 47 6.03291 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 65C12.0455 62 13.0398 47 13.0398 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M28 65C20.0455 61 21.0398 47 21.0398 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M37 65C29.0455 61 30.0398 47 30.0398 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M45 65C38.5462 62 39.0072 48 39.0072 44"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M53 65C48 61 48 48 48 44"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M61 65C57 61.0976 57 48.9024 57 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M69 65C66 61.0976 66 48.9024 66 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M77 65C75 61 75 48.5 75 44.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M85 65C84 61.0976 84 48.9024 84 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 65C172.963 61 171.967 47 171.967 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M157 65C164.955 62 163.96 47 163.96 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 65C156.955 61 155.96 47 155.96 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M141 65C148.955 61 147.96 47 147.96 43"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M133 65C139.454 62 138.993 48 138.993 44"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M125 65C130 61 130 48 130 44"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M117 65C121 61.0976 121 48.9024 121 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M109 65C112 61.0976 112 48.9024 112 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M101 65C103 61 103 48.5 103 44.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M93 65C94 61.0976 94 48.9024 94 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M14 5C5.03705 9 6.03293 23 6.03291 27"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 5C12.0455 8 13.0398 23 13.0398 27"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M21.0398 27C21.0398 23.285 20.1821 10.9441 26.4325 6"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M30.0398 27C30.0398 23.285 29.1821 10.9441 35.4325 6"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39.0072 26C39.0072 22.3399 38.6212 10.3071 43.5 5.99017"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M48 26C48 22.2867 48 10.8175 52 5.99231"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M56.9999 25C56.9999 21.6259 56.9999 12.0527 59.5853 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M66 25C66 21.6259 66 12.0527 67.939 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M75 25.5C75 22.0304 75 12.1656 76.3052 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M83.9999 25C83.9999 21.6259 83.9999 12.0527 84.6462 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 5C172.963 9 171.967 23 171.967 27"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M163.96 27C163.96 23.1762 164.869 9.30021 158 5.46436"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M155.96 27C155.96 23.285 156.818 10.9441 150.568 6"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M147.96 27C147.96 23.292 148.815 10.9903 142.603 6.02783"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M138.993 26C138.993 22.3427 139.378 10.3253 134.511 6"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M130 26C130 22.2887 130 10.8297 126.006 6"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M121 25C121 21.6259 121 12.0527 118.415 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M112 25C112 21.6065 112 11.9423 110.027 6.91321"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M103 25.5C103 22.0304 103 12.1656 101.695 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M94 25C94 21.6259 94 12.0527 93.3536 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
